<template>
  <div>
    <st-header v-show="!getRouter"></st-header>
    <!-- 面包屑 -->
    <breadcrumb class="breadcrumb-container" />
    <!-- 页面内容 -->
    <app-main />
    <StFooter></StFooter>
  </div>
</template>

<script>
import StHeader from "@/layout/header";
import StFooter from "@/layout/footer";
import { AppMain, Breadcrumb } from "./components";
export default {
  name: "Index",
  components: {
    StHeader,
    Breadcrumb,
    AppMain,
    StFooter,
  },
  data() {
    return {};
  },

  methods: {},

  computed: {
    getRouter() {
      let paths = [];
      let matchArr = [];
      paths.forEach(item => {
        if (this.$route.path.includes(item)) {
          matchArr.push(item);
        }
      });
      return matchArr.length > 0;
    }
  }
};
</script>

<style scoped></style>
